var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c(
        "v-container",
        { staticClass: "py-0 px-1", attrs: { fluid: "", "fill-height": "" } },
        [
          _c(
            "v-layout",
            { attrs: { "justify-center": "", "align-center": "" } },
            [
              _c(
                "v-flex",
                { attrs: { shrink: "" } },
                [
                  _vm._t("default"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey darken-1",
                        dark: "",
                        fab: "",
                        fixed: "",
                        bottom: "",
                        left: ""
                      },
                      on: {
                        click: function($event) {
                          _vm.changeZoom("out")
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("zoom_out")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticStyle: {
                        "margin-left": "55px",
                        "margin-bottom": "10px"
                      },
                      attrs: {
                        color: "white",
                        fixed: "",
                        disabled: "",
                        bottom: "",
                        left: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(parseInt(_vm.canvasZoom)) +
                          " %\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticStyle: { "margin-left": "142px" },
                      attrs: {
                        color: "grey darken-1",
                        dark: "",
                        fab: "",
                        fixed: "",
                        bottom: "",
                        left: ""
                      },
                      on: {
                        click: function($event) {
                          _vm.changeZoom("in")
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("zoom_in")])],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f8aa36d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f8aa36d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/appLayouts/NoSidebar.vue
// module id = null
// module chunks = 